import { cn } from "@/lib/utils";

type AssistantContentProps = {
  content: string;
  className?: string;
};

function isBulletLine(line: string) {
  const trimmed = line.trimStart();
  return trimmed.startsWith("•") || trimmed.startsWith("-");
}

export function AssistantContent({ content, className }: AssistantContentProps) {
  const lines = content.split("\n");
  const hasBullets = lines.some(isBulletLine);

  if (!hasBullets) {
    return (
      <div className={cn("whitespace-pre-wrap text-sm leading-relaxed", className)}>
        {content}
      </div>
    );
  }

  const blocks: Array<{ type: "text" | "list"; lines: string[] }> = [];
  let current: { type: "text" | "list"; lines: string[] } | null = null;

  for (const line of lines) {
    const type = isBulletLine(line) ? "list" : "text";
    if (!current || current.type !== type) {
      current = { type, lines: [] };
      blocks.push(current);
    }
    current.lines.push(line);
  }

  return (
    <div className={cn("space-y-2 text-sm leading-relaxed", className)}>
      {blocks.map((block, index) => {
        if (block.type === "list") {
          return (
            <ul key={index} className="list-disc space-y-1 pl-5">
              {block.lines.map((line, lineIndex) => (
                <li key={lineIndex} className="whitespace-pre-wrap">
                  {line.trimStart().replace(/^[•-]\s*/, "")}
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={index} className="whitespace-pre-wrap">
            {block.lines.join("\n")}
          </p>
        );
      })}
    </div>
  );
}
